import { render, staticRenderFns } from "./MyConcern.vue?vue&type=template&id=54fd5d0a&"
import script from "./MyConcern.vue?vue&type=script&lang=js&"
export * from "./MyConcern.vue?vue&type=script&lang=js&"
import style0 from "./MyConcern.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports